export default __webpack_public_path__ + "static/media/IMG7544.28a124c5.jpg";